import React, { useState } from "react";
import "./CommonDoctorCard.css";
import Green_btn from "../common_btn/green_btn/Green_btn";
import { Rating } from "react-simple-star-rating";
import AppointmentModal from "../common_modal/appointment_modal/AppointmentModal";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";
export default function CommonDoctorCard({
  image,
  specialist,
  name,
  hospital,
  ratingg,
  reviews,
  price,
  historyShow = false,
  id,
  average_rating,
  doctor,
  onDoctorClick, // New prop
  appointmentStatus,
}) {
  const navigate = useNavigate();
  const [rating, setRating] = useState(5);
  const [showModal, setShowModal] = useState(false);
  const handleRating = (rate) => {
    setRating(rate);
  };
  const handleDoctorClick = () => {
    if (onDoctorClick) {
      onDoctorClick(id, doctor);
    } else {
      navigate(`/doctor-detail/${encodeId(id)}`);
    }
  };

  return (
    <div className="Common-Doctor-Card-section">
      <div
        className="doctor-left"
        // onClick={() => navigate(`/doctor-detail/${encodeId(id)}`)}
        onClick={handleDoctorClick}
        style={{ cursor: "pointer" }}
      >
        <div className="doctor-image">
          <img className="img" src={image} alt={name} />
        </div>

        <div className="doctor-info">
          <span className="doctor-specialist">{specialist}</span>

          <h3 className="doctor-name">{name}</h3>

          <p className="doctor-hospital">{hospital}</p>

          {!historyShow && (
            <div className="doctor-rating">
              {" "}
              <Rating
                // initialValue={5}
                initialValue={Number(average_rating)}
                readonly
                size={18}
                allowFraction
              />
              <span className="rating-no">({average_rating || "0"})</span>
            </div>
          )}
        </div>
      </div>

      <div className="doctor-right">
        {historyShow ? (
          <div className="date-wrapper">
            <p className="date-time">
              <span className="heading"> Date:-</span>{" "}
              <span className="value">12 March</span>
            </p>

            <p className="date-time">
              <span className="heading">Timing:-</span>{" "}
              <span className="value">11:00 AM</span>
            </p>
            <p className="date-time">
              <span className="heading">Status:-</span>{" "}
              <span className="value">{appointmentStatus || ""}</span>
            </p>
          </div>
        ) : (
          <div className="doctor-price">
            <h2>₹{price}</h2>
            <span className="sub-taxt">Consultation Fees</span>
          </div>
        )}
        <Green_btn
          btnText={historyShow ? "Book Again" : "Book Now"}
          onClick={() => setShowModal(true)}
        />
      </div>
      <AppointmentModal
        doctor={doctor}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </div>
  );
}
